import { createSlotRecipe } from './runtime.js';

const helpTextConfig = {"name":"helpText","slots":["root","icon"],"variantMap":{"variant":["error","info","link","success","warning"]}}

export const helpText = /* @__PURE__ */ createSlotRecipe(helpTextConfig)